// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3fXy5","savePackageButton":"ClientWallet_savePackageButton__29dVU"};